/**
 * @name Schedule
 * @description Componente de horario en configuración de perfil
 * @author Gerardo de León
 */

import React, { Component } from 'react';
import i18n from 'i18next';
import { Formik } from 'formik';
import moment from 'moment';
import styled from 'styled-components';

import { Environment } from '@tycommon/config';
import { ScheduleService, ResponseHandlerService, NotificationsService } from '@tycommon/services';
import { MUI, Typography } from '@tycommon/styles';

import { trackPromise } from 'react-promise-tracker';

class Schedule extends Component {
  constructor(props) {
    super(props);
    const infoUsuario = JSON.parse(localStorage.getItem('ls.infoUsuario') || '{}');
    this.employee = infoUsuario && infoUsuario.Empleado ? infoUsuario.Empleado : null;
    if (!this.employee) {
      window.location.href = '/login';
      return;
    }
    this.state = {
      employeeId: this.employee.IdEmpleado,
      supervisorId: this.employee.IdReporta,
      employeeName: `${this.employee.Nombres} ${this.employee.Apellidos}`,
      status: 0,
      statusName: '',
      entryId: 0,
      exitId: 0,
      monday: moment(),
      tuesday: moment(),
      wednesday: moment(),
      thursday: moment(),
      friday: moment(),
      saturday: moment(),
      sunday: moment(),
      mondayOut: moment(),
      tuesdayOut: moment(),
      wednesdayOut: moment(),
      thursdayOut: moment(),
      fridayOut: moment(),
      saturdayOut: moment(),
      sundayOut: moment(),
      visibleMonday: false,
      visibleTuesday: false,
      visibleWednesday: false,
      visibleThursday: false,
      visibleFriday: false,
      visibleSaturday: false,
      visibleSunday: false,
    };
  }

  componentDidMount() {
    const { employeeId } = this.state;
    this.getSchedule(employeeId);
  }

  getSchedule = (employeeId) => {
    trackPromise(
      ScheduleService.get(employeeId)
        .then((response) => {

          let entry = response.Entrada;
          let exit = response.Salida;
          let aviable = response.HorarioDisponible;

          if (entry) {
            this.setState({
              // Entrada
              entryId: entry.IdHorarioEntrada,
              monday: moment(`1999-01-01T${entry.Lunes}`),
              tuesday: moment(`1999-01-01T${entry.Martes}`),
              wednesday: moment(`1999-01-01T${entry.Miercoles}`),
              thursday: moment(`1999-01-01T${entry.Jueves}`),
              friday: moment(`1999-01-01T${entry.Viernes}`),
              saturday: moment(`1999-01-01T${entry.Sabado}`),
              sunday: moment(`1999-01-01T${entry.Domingo}`),

              // Salida
              exitId: exit.IdHorarioSalida,
              mondayOut: moment(`1999-01-01T${exit.Lunes}`),
              tuesdayOut: moment(`1999-01-01T${exit.Martes}`),
              wednesdayOut: moment(`1999-01-01T${exit.Miercoles}`),
              thursdayOut: moment(`1999-01-01T${exit.Jueves}`),
              fridayOut: moment(`1999-01-01T${exit.Viernes}`),
              saturdayOut: moment(`1999-01-01T${exit.Sabado}`),
              sundayOut: moment(`1999-01-01T${exit.Domingo}`),

              // Horario hábil
              visibleMonday: aviable.Lunes,
              visibleTuesday: aviable.Martes,
              visibleWednesday: aviable.Miercoles,
              visibleThursday: aviable.Jueves,
              visibleFriday: aviable.Viernes,
              visibleSaturday: aviable.Sabado,
              visibleSunday: aviable.Domingo,

              // Estatus
              status: response.IdEstatus,
              statusName: response.Estatus,
            });
          }
        }).catch((error) => {
          ResponseHandlerService.error(error);
        }));
  }

  checkStatus = (employeeId) => {
    ScheduleService.getStatus(employeeId)
      .then((response) => {
        this.setState({
          status: response.IdEstatus,
          statusName: response.Estatus
        });
      }).catch((error) => {
        ResponseHandlerService.error(error);
      });
  }

  saveSchedule = (values, setSubmitting) => {
    const { employeeId, employeeName, supervisorId } = this.state;

    let request = {
      IdEmpleado: employeeId,
      IdHorarioEntrada: values.entryId,
      IdHorarioSalida: values.exitId,
      Horario: [{
        IdHorarioEntrada: values.entryId,
        Domingo: moment(values.sunday).format('HH:mm:ss'),
        Lunes: moment(values.monday).format('HH:mm:ss'),
        Martes: moment(values.tuesday).format('HH:mm:ss'),
        Miercoles: moment(values.wednesday).format('HH:mm:ss'),
        Jueves: moment(values.thursday).format('HH:mm:ss'),
        Viernes: moment(values.friday).format('HH:mm:ss'),
        Sabado: moment(values.saturday).format('HH:mm:ss'),
      }, {
        IdHorarioSalida: values.exitId,
        Domingo: moment(values.sundayOut).format('HH:mm:ss'),
        Lunes: moment(values.mondayOut).format('HH:mm:ss'),
        Martes: moment(values.tuesdayOut).format('HH:mm:ss'),
        Miercoles: moment(values.wednesdayOut).format('HH:mm:ss'),
        Jueves: moment(values.thursdayOut).format('HH:mm:ss'),
        Viernes: moment(values.fridayOut).format('HH:mm:ss'),
        Sabado: moment(values.saturdayOut).format('HH:mm:ss'),
      }],
      aviable: {
        Domingo: values.visibleSunday,
        Lunes: values.visibleMonday,
        Martes: values.visibleTuesday,
        Miercoles: values.visibleWednesday,
        Jueves: values.visibleThursday,
        Viernes: values.visibleFriday,
        Sabado: values.visibleSaturday,
      }
    };

    // Notificación - Tienes el horario pendiente por aprobar de <colaborador>
    let notificationToSend = {
      IdAmbiente: Environment.getCurrent().environmentId,
      URL: '#/configuraperfil',
      IdTipoNotificacion: 125,
      IdEmpleado: supervisorId,
      Parametros: JSON.stringify({ filter: { Id: employeeId, IdReporta: supervisorId, Nombre: employeeName }, Tab: 5 }),
      Propiedades: JSON.stringify({ colaborador: employeeName })
    };

    ScheduleService.putAviable(request.aviable)
      .then(() => {
        ScheduleService.put(request)
          .then((response) => {
            this.checkStatus(employeeId);
            if (employeeId !== notificationToSend.IdEmpleado) {
              NotificationsService.post(notificationToSend);
            }
            ResponseHandlerService.success(response);
          }).catch((error) => {
            setSubmitting(false);
            ResponseHandlerService.error(error);
          });
      })
      .catch((error) => {
        setSubmitting(false);
        ResponseHandlerService.error(error);
      });
  }

  onChange = (event, day) => {
    switch (day) {
      case ('monday'):
        this.setState({ monday: event });
        break;
      case ('tuesday'):
        this.setState({ tuesday: event });
        break;
      case ('wednesday'):
        this.setState({ wednesday: event });
        break;
      case ('thursday'):
        this.setState({ thursday: event });
        break;
      case ('friday'):
        this.setState({ friday: event });
        break;
      case ('saturday'):
        this.setState({ saturday: event });
        break;
      case ('sunday'):
        this.setState({ sunday: event });
        break;
      case ('mondayOut'):
        this.setState({ mondayOut: event });
        break;
      case ('tuesdayOut'):
        this.setState({ tuesdayOut: event });
        break;
      case ('wednesdayOut'):
        this.setState({ wednesdayOut: event });
        break;
      case ('thursdayOut'):
        this.setState({ thursdayOut: event });
        break;
      case ('fridayOut'):
        this.setState({ fridayOut: event });
        break;
      case ('saturdayOut'):
        this.setState({ saturdayOut: event });
        break;
      case ('sundayOut'):
        this.setState({ sundayOut: event });
        break;
      default:
        break;
    }
  }

  handleChange = (event) => {
    switch (event.target.name) {
      case 'visibleMonday':
        this.setState({ visibleMonday: event.target.checked });
        break;
      case 'visibleTuesday':
        this.setState({ visibleTuesday: event.target.checked });
        break;
      case 'visibleWednesday':
        this.setState({ visibleWednesday: event.target.checked });
        break;
      case 'visibleThursday':
        this.setState({ visibleThursday: event.target.checked });
        break;
      case 'visibleFriday':
        this.setState({ visibleFriday: event.target.checked });
        break;
      case 'visibleSaturday':
        this.setState({ visibleSaturday: event.target.checked });
        break;
      case 'visibleSunday':
        this.setState({ visibleSunday: event.target.checked });
        break;
      default:
        break;
    }
  };

  render() {
    const {
      entryId,
      exitId,
      monday,
      tuesday,
      wednesday,
      thursday,
      friday,
      saturday,
      sunday,
      mondayOut,
      tuesdayOut,
      wednesdayOut,
      thursdayOut,
      fridayOut,
      saturdayOut,
      sundayOut,
      visibleMonday,
      visibleTuesday,
      visibleWednesday,
      visibleThursday,
      visibleFriday,
      visibleSaturday,
      visibleSunday,
      status,
      statusName,
    } = this.state;

    return (
      <>
        <Formik
          enableReinitialize
          initialValues={{ monday, tuesday, wednesday, thursday, friday, saturday, sunday, mondayOut, tuesdayOut, wednesdayOut, thursdayOut, fridayOut, saturdayOut, sundayOut, visibleMonday, visibleTuesday, visibleWednesday, visibleThursday, visibleFriday, visibleSaturday, visibleSunday, entryId, exitId }}
          onSubmit={(values, { setSubmitting }) => {
            this.saveSchedule(values, setSubmitting);
          }}
        >
          {(formikProps) => {
            return (
              <>
                <MUI.Box padding="8px">
                  <MUI.Grid container direction="row" alignItems="center">
                    {/* Días Laborales */}
                    <Styled.Label>
                      <Typography.H6>{i18n.t('Shedule.workdays')}</Typography.H6>
                    </Styled.Label>
                    {/* Lunes */}
                    <Styled.BoxRow>
                      <MUI.Grid container alignItems="center">
                        <MUI.Grid item md={2} sm={2} xs={12}>
                          <Styled.BoxSwitch>
                            <MUI.SwitchLabel
                              label={i18n.t('WeekDays.monday')}
                              control={<MUI.Switch checked={visibleMonday} onChange={this.handleChange} name="visibleMonday" />}
                            />
                          </Styled.BoxSwitch>
                        </MUI.Grid>
                        <MUI.Grid item md={4} sm={5} xs={6}>
                          {formikProps.values.visibleMonday && (
                            <Styled.BoxRowClock>
                              <MUI.TimePicker
                                label={i18n.t('Shedule.checkIn')}
                                value={formikProps.values.monday}
                                onChange={(newDate) => this.onChange(newDate, 'monday')}
                                orientation="landscape"
                                openTo="hours"
                                views={['hours', 'minutes']}
                              />
                            </Styled.BoxRowClock>
                          )}
                        </MUI.Grid>
                        <MUI.Grid item md={4} sm={5} xs={6}>
                          {formikProps.values.visibleMonday && (
                            <Styled.BoxRowClock>
                              <MUI.TimePicker
                                label={i18n.t('Shedule.departure')}
                                value={formikProps.values.mondayOut}
                                onChange={(newDate) => this.onChange(newDate, 'mondayOut')}
                                orientation="landscape"
                                openTo="hours"
                                views={['hours', 'minutes']}
                              />
                            </Styled.BoxRowClock>
                          )}
                        </MUI.Grid>
                      </MUI.Grid>
                    </Styled.BoxRow>
                    {/* Martes */}
                    <Styled.BoxRow>
                      <MUI.Grid container alignItems="center">
                        <MUI.Grid item md={2} sm={2} xs={12}>
                          <Styled.BoxSwitch>
                            <MUI.SwitchLabel
                              label={i18n.t('WeekDays.tuesday')}
                              control={<MUI.Switch checked={visibleTuesday} onChange={this.handleChange} name="visibleTuesday" />}
                            />
                          </Styled.BoxSwitch>
                        </MUI.Grid>
                        <MUI.Grid item md={4} sm={5} xs={6}>
                          {formikProps.values.visibleTuesday && (
                            <Styled.BoxRowClock>
                              <MUI.TimePicker
                                label={i18n.t('Shedule.checkIn')}
                                value={formikProps.values.tuesday}
                                onChange={(newDate) => this.onChange(newDate, 'tuesday')}
                                orientation="landscape"
                                openTo="hours"
                                views={['hours', 'minutes']}
                              />
                            </Styled.BoxRowClock>
                          )}
                        </MUI.Grid>
                        <MUI.Grid item md={4} sm={5} xs={6}>
                          {formikProps.values.visibleTuesday && (
                            <Styled.BoxRowClock>
                              <MUI.TimePicker
                                label={i18n.t('Shedule.departure')}
                                value={formikProps.values.tuesdayOut}
                                onChange={(newDate) => this.onChange(newDate, 'tuesdayOut')}
                                orientation="landscape"
                                openTo="hours"
                                views={['hours', 'minutes']}
                              />
                            </Styled.BoxRowClock>
                          )}
                        </MUI.Grid>
                      </MUI.Grid>
                    </Styled.BoxRow>
                    {/* Miercoles */}
                    <Styled.BoxRow>
                      <MUI.Grid container alignItems="center">
                        <MUI.Grid item md={2} sm={2} xs={12}>
                          <Styled.BoxSwitch>
                            <MUI.SwitchLabel
                              label={i18n.t('WeekDays.wednesday')}
                              control={<MUI.Switch checked={visibleWednesday} onChange={this.handleChange} name="visibleWednesday" />}
                            />
                          </Styled.BoxSwitch>
                        </MUI.Grid>
                        <MUI.Grid item md={4} sm={5} xs={6}>
                          {formikProps.values.visibleWednesday && (
                            <Styled.BoxRowClock>
                              <MUI.TimePicker
                                label={i18n.t('Shedule.checkIn')}
                                value={formikProps.values.wednesday}
                                onChange={(newDate) => this.onChange(newDate, 'wednesday')}
                                orientation="landscape"
                                openTo="hours"
                                views={['hours', 'minutes']}
                              />
                            </Styled.BoxRowClock>
                          )}
                        </MUI.Grid>
                        <MUI.Grid item md={4} sm={5} xs={6}>
                          {formikProps.values.visibleWednesday && (
                            <Styled.BoxRowClock>
                              <MUI.TimePicker
                                label={i18n.t('Shedule.departure')}
                                value={formikProps.values.wednesdayOut}
                                onChange={(newDate) => this.onChange(newDate, 'wednesdayOut')}
                                orientation="landscape"
                                openTo="hours"
                                views={['hours', 'minutes']}
                              />
                            </Styled.BoxRowClock>
                          )}
                        </MUI.Grid>
                      </MUI.Grid>
                    </Styled.BoxRow>
                    {/* Jueves */}
                    <Styled.BoxRow>
                      <MUI.Grid container alignItems="center">
                        <MUI.Grid item md={2} sm={2} xs={12}>
                          <Styled.BoxSwitch>
                            <MUI.SwitchLabel
                              label={i18n.t('WeekDays.thursday')}
                              control={<MUI.Switch checked={visibleThursday} onChange={this.handleChange} name="visibleThursday" />}
                            />
                          </Styled.BoxSwitch>
                        </MUI.Grid>
                        <MUI.Grid item md={4} sm={5} xs={6}>
                          {formikProps.values.visibleThursday && (
                            <Styled.BoxRowClock>
                              <MUI.TimePicker
                                label={i18n.t('Shedule.checkIn')}
                                value={formikProps.values.thursday}
                                onChange={(newDate) => this.onChange(newDate, 'thursday')}
                                orientation="landscape"
                                openTo="hours"
                                views={['hours', 'minutes']}
                              />
                            </Styled.BoxRowClock>
                          )}
                        </MUI.Grid>
                        <MUI.Grid item md={4} sm={5} xs={6}>
                          {formikProps.values.visibleThursday && (
                            <Styled.BoxRowClock>
                              <MUI.TimePicker
                                label={i18n.t('Shedule.departure')}
                                value={formikProps.values.thursdayOut}
                                onChange={(newDate) => this.onChange(newDate, 'thursdayOut')}
                                orientation="landscape"
                                openTo="hours"
                                views={['hours', 'minutes']}
                              />
                            </Styled.BoxRowClock>
                          )}
                        </MUI.Grid>
                      </MUI.Grid>
                    </Styled.BoxRow>
                    {/* Viernes */}
                    <Styled.BoxRow>
                      <MUI.Grid container alignItems="center">
                        <MUI.Grid item md={2} sm={2} xs={12}>
                          <Styled.BoxSwitch>
                            <MUI.SwitchLabel
                              label={i18n.t('WeekDays.friday')}
                              control={<MUI.Switch checked={visibleFriday} onChange={this.handleChange} name="visibleFriday" />}
                            />
                          </Styled.BoxSwitch>
                        </MUI.Grid>
                        <MUI.Grid item md={4} sm={5} xs={6}>
                          {formikProps.values.visibleFriday && (
                            <Styled.BoxRowClock>
                              <MUI.TimePicker
                                label={i18n.t('Shedule.checkIn')}
                                value={formikProps.values.friday}
                                onChange={(newDate) => this.onChange(newDate, 'friday')}
                                orientation="landscape"
                                openTo="hours"
                                views={['hours', 'minutes']}
                              />
                            </Styled.BoxRowClock>
                          )}
                        </MUI.Grid>
                        <MUI.Grid item md={4} sm={5} xs={6}>
                          {formikProps.values.visibleFriday && (
                            <Styled.BoxRowClock>
                              <MUI.TimePicker
                                label={i18n.t('Shedule.departure')}
                                value={formikProps.values.fridayOut}
                                onChange={(newDate) => this.onChange(newDate, 'fridayOut')}
                                orientation="landscape"
                                openTo="hours"
                                views={['hours', 'minutes']}
                              />
                            </Styled.BoxRowClock>
                          )}
                        </MUI.Grid>
                      </MUI.Grid>
                    </Styled.BoxRow>
                    {/* Sabado */}
                    <Styled.BoxRow>
                      <MUI.Grid container alignItems="center">
                        <MUI.Grid item md={2} sm={2} xs={12}>
                          <Styled.BoxSwitch>
                            <MUI.SwitchLabel
                              label={i18n.t('WeekDays.saturday')}
                              control={<MUI.Switch checked={visibleSaturday} onChange={this.handleChange} name="visibleSaturday" />}
                            />
                          </Styled.BoxSwitch>
                        </MUI.Grid>
                        <MUI.Grid item md={4} sm={5} xs={6}>
                          {formikProps.values.visibleSaturday && (
                            <Styled.BoxRowClock>
                              <MUI.TimePicker
                                label={i18n.t('Shedule.checkIn')}
                                value={formikProps.values.saturday}
                                onChange={(newDate) => this.onChange(newDate, 'saturday')}
                                orientation="landscape"
                                openTo="hours"
                                views={['hours', 'minutes']}
                              />
                            </Styled.BoxRowClock>
                          )}
                        </MUI.Grid>
                        <MUI.Grid item md={4} sm={5} xs={6}>
                          {formikProps.values.visibleSaturday && (
                            <Styled.BoxRowClock>
                              <MUI.TimePicker
                                label={i18n.t('Shedule.departure')}
                                value={formikProps.values.saturdayOut}
                                onChange={(newDate) => this.onChange(newDate, 'saturdayOut')}
                                orientation="landscape"
                                openTo="hours"
                                views={['hours', 'minutes']}
                              />
                            </Styled.BoxRowClock>
                          )}
                        </MUI.Grid>
                      </MUI.Grid>
                    </Styled.BoxRow>
                    {/* Domingo */}
                    <Styled.BoxRow>
                      <MUI.Grid container alignItems="center">
                        <MUI.Grid item md={2} sm={2} xs={12}>
                          <Styled.BoxSwitch>
                            <MUI.SwitchLabel
                              label={i18n.t('WeekDays.sunday')}
                              control={<MUI.Switch checked={visibleSunday} onChange={this.handleChange} name="visibleSunday" />}
                            />
                          </Styled.BoxSwitch>
                        </MUI.Grid>
                        <MUI.Grid item md={4} sm={5} xs={6}>
                          {formikProps.values.visibleSunday && (
                            <Styled.BoxRowClock>
                              <MUI.TimePicker
                                label={i18n.t('Shedule.checkIn')}
                                value={formikProps.values.sunday}
                                onChange={(newDate) => this.onChange(newDate, 'sunday')}
                                orientation="landscape"
                                openTo="hours"
                                views={['hours', 'minutes']}
                              />
                            </Styled.BoxRowClock>
                          )}
                        </MUI.Grid>
                        <MUI.Grid item md={4} sm={5} xs={6}>
                          {formikProps.values.visibleSunday && (
                            <Styled.BoxRowClock>
                              <MUI.TimePicker
                                label={i18n.t('Shedule.departure')}
                                value={formikProps.values.sundayOut}
                                onChange={(newDate) => this.onChange(newDate, 'sundayOut')}
                                orientation="landscape"
                                openTo="hours"
                                views={['hours', 'minutes']}
                              />
                            </Styled.BoxRowClock>
                          )}
                        </MUI.Grid>
                      </MUI.Grid>
                    </Styled.BoxRow>
                  </MUI.Grid>
                </MUI.Box>

                <MUI.Box padding="8px">
                  <Styled.BoxStatus>
                    <Typography.Text>
                      {`${i18n.t('GenericMessages.status')}: `}
                      <Typography.Strong>{statusName}</Typography.Strong>
                    </Typography.Text>
                  </Styled.BoxStatus>
                  {status !== 2 && (
                    <Styled.BoxActions>
                      <MUI.ButtonCTA type="button" color="primary" disabled={formikProps.isSubmitting} onClick={formikProps.handleSubmit}>
                        {status === 4 || status === 1 ? i18n.t('GenericMessages.sendToAuth') : i18n.t('Responsibilities.revertStatus')}
                      </MUI.ButtonCTA>
                    </Styled.BoxActions>
                  )}
                </MUI.Box>
              </>
            );
          }}
        </Formik>
      </>
    );
  }
}

// *************************************
// STYLED COMPONENTS
// *************************************

const Styled = {};

Styled.BoxRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 88px;
  width: 100%;
  padding: 8px;
`;

Styled.BoxSwitch = styled.div`
  width: 100%;
  padding: 8px;
`;

Styled.BoxRowClock = styled.div`
  width: 100%;
  padding: 0 8px;
`;

Styled.BoxActions = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

Styled.BoxStatus = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 8px;
`;

Styled.Label = styled.div`
  padding: 8px;
`;

export default Schedule;
